import { useEffect } from 'react';

const usePullDownToClose = ({
  enabled,
  showModal,
  setShowModal
}) => {
  const pullDownToCloseModal = ({ closeModal }) => {
    const overlay = document.querySelector(
      ".ReactModal__Overlay"
    );
    const modal = document.querySelector(
      ".ReactModal__Content"
    );
    if (!modal || !overlay) return;
    const header = modal.querySelector(
      "[data-modal-header-line]"
    );
    if (!header) return;
    const modalHeight = modal.offsetHeight || 200;
    const swipeHeight = 100;
    let touchDown = false;
    let firstTouchPos = 0;
    header.addEventListener("touchstart", (e) => {
      touchDown = true;
      firstTouchPos = e.touches[0].pageY;
    });
    header.addEventListener("touchmove", (e) => {
      e.preventDefault();
      if (touchDown) {
        const diff = e.touches[0].pageY - firstTouchPos;
        if (overlay) {
          overlay.style.top = `${diff < 0 ? 0 : diff}px`;
        }
        if (diff > modalHeight - swipeHeight) {
          closeModal();
          touchDown = false;
        }
      }
    });
    header.addEventListener("touchend", (e) => {
      if (!touchDown) return;
      const distanceDiff = e.changedTouches[0].pageY - firstTouchPos;
      if (distanceDiff > 100 || distanceDiff > modalHeight / 2 - modalHeight / 10) {
        closeModal();
      } else if (overlay) {
        overlay.style.top = "0px";
      }
      touchDown = false;
    });
  };
  useEffect(() => {
    if (!enabled) return;
    if (!showModal) return;
    setTimeout(() => {
      pullDownToCloseModal({
        closeModal: () => {
          setShowModal(false);
        }
      });
    }, 10);
  }, [enabled, showModal, setShowModal]);
};

export { usePullDownToClose };
//# sourceMappingURL=usePullDownToClose.js.map
